<template>
  <div>
    <Header />

    <main role="main" id="bodyContent">
      <div class="wrapper cl">
        <section class="box-cont">
          <Nav />

          <article>
            <form action="#" method="post">
              <div class="dos-columnas">
                <div class="columna1">
                  <div v-if="step.numPresupuesto" class="numPresupuesto">
                    <span>Ref: {{ step.numPresupuesto }}</span>
                  </div>
                  <Ayuda />

                  <slot name="ayuda" />

                  <slot name="content" />
                </div>

                <div class="columna2">
                  <img :src="imageUrl" class="imagen" />
                </div>
              </div>
            </form>
          </article>
        </section>

        <div class="actions cl">
          <span class="back flt">
            <slot name="botonAtras" />
          </span>
          <span class="btn frt">
            <slot name="botonSiguiente" />
          </span>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
let api_url = "/produccion";
export default {
  store: ["step"],

  computed: {
    imageUrl() {
      let grupoNavegacion =
        this.step.grupoNavegacion == null ? "d" : this.step.grupoNavegacion;
      return api_url + "/online/getImagenPubli/" + grupoNavegacion;
      //return "http://www.1x1px.me/FFFFFF-0.0.png";
    }
  }
};
</script>

<style lang="scss" scoped>
.numPresupuesto {
  font-size: 2rem;
  font-weight: 400;
  color: white;
  padding-right: 1rem;
  text-align: right;
  span {
    background-color: #999;
    border-radius: 0.5rem;
    padding: 0.2rem 0.6rem 0.2rem 0.6rem;
  }
}

.dos-columnas {
  padding: 2rem;
  display: flex;
  flex-direction: row nowrap;
}

.columna1 {
  flex-grow: 1;

  @media (min-width: 1023px) {
    border-right: 1px solid #aaa;
  }
}

.columna2 {
  display: none;
  @media (min-width: 1023px) {
    display: block;
  }
}

.imagen {
  width: 500px;
  padding-left: 2rem;
}
</style>
